import { useTranslation } from 'react-i18next'

import { BonusChip, ComboBox } from '@reveni-io/reveni-ui'

import { refundMethodsOptions } from './constants'
import { getExtraValue } from './helpers'
import * as Styles from './styles'

const RefundMethodSelector = ({ refundMethods, currency, onChange, refundMethod }) => {
  const { t, i18n } = useTranslation()

  const getOptions = () => {
    return refundMethods?.map(method => {
      const { label, Icon } = refundMethodsOptions[method.name]
      return {
        label: (
          <Styles.OptionContainer>
            <Icon size={16} />
            {t(label)}
            {method.extra_value && <BonusChip label={`${getExtraValue(method, i18n.language, currency)} extra`} />}
          </Styles.OptionContainer>
        ),
        value: method.name,
      }
    })
  }

  const handleChange = refundMethod => {
    const selectedRefundMethod = refundMethods.find(rm => rm.name === refundMethod.target.value)
    onChange(selectedRefundMethod)
  }

  return (
    <ComboBox
      label={t('Método de reembolso')}
      value={refundMethod}
      menuItems={getOptions()}
      handleChange={handleChange}
      fullWidth
    />
  )
}

export default RefundMethodSelector
